import "./styles.scss";
import React from "react";

const PostShare = ({ data }) => {
  const url = `https://spokojwglowie.pl${data?.uri}`;

  const list_data = [
    {
      text: "Chcesz być na bieżąco z naszymi artykułami psychologicznymi?",
      button: {
        label: "Polub nas na facebook",
        href: "https://www.facebook.com/spokojwglowie/",
        color: "orange",
      },
    },
    {
      text: "Udostępnij wpis na Facebooku, aby pomóc innym osobom!",
      button: {
        label: "Udostępnij ten artykuł",
        href: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        color: "purple",
      },
    },
  ];

  return (
    <div className="container">
      <div className="post-share">
        {list_data?.map((item, index) => (
          <div key={index} className="post-share__col">
            <span>{item?.text}</span>
            <a
              target="_blank"
              rel="noreferrer"
              href={item?.button?.href}
              className={`button button--${item?.button?.color} button--small`}
            >
              {item?.button?.label}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostShare;
